import {
  Ban,
  Beer,
  BookOpen,
  CalendarDays,
  ClipboardList,
  Coffee,
  Compass,
  Croissant,
  Flag,
  Flower2,
  Frame,
  Home,
  Landmark,
  MapPin,
  Mountain,
  ParkingCircle,
  PawPrint,
  PartyPopper,
  Recycle,
  ShieldCheck,
  ShoppingBag,
  Sparkles,
  Store,
  TreePine,
  Trees,
  Users,
  UtensilsCrossed,
  VolumeX,
  Waves,
  Wine,
  type LucideIcon,
} from "lucide-react"
import type { HighlightSlot } from "../types"

export type NavKey = "home" | "explore" | "guide"
export type HouseRuleKey =
  | "quietHours"
  | "smoking"
  | "pets"
  | "visitors"
  | "parties"
  | "waste"
  | "safety"
  | "parking"
  | "outdoor"
  | "custom"
export type PropertyInfoKey = "parking" | "waste" | "supermarket"

const PLACE_TYPE_ICON_MAP: Record<string, LucideIcon> = {
  restaurant: UtensilsCrossed,
  bistro: UtensilsCrossed,
  bar: Wine,
  wine_bar: Wine,
  pub: Beer,
  cafe: Coffee,
  coffee: Coffee,
  bakery: Croissant,
  ice_cream: Croissant,
  beach: Waves,
  nature: TreePine,
  park: Trees,
  hiking: Mountain,
  attraction: Compass,
  museum: Landmark,
  gallery: Frame,
  spa: Sparkles,
  golf: Flag,
  shop: ShoppingBag,
  boutique: ShoppingBag,
  market: Store,
  supermarket: Store,
}

const HOUSE_RULE_ICON_MAP: Record<HouseRuleKey, LucideIcon> = {
  quietHours: VolumeX,
  smoking: Ban,
  pets: PawPrint,
  visitors: Users,
  parties: PartyPopper,
  waste: Recycle,
  safety: ShieldCheck,
  parking: ParkingCircle,
  outdoor: Flower2,
  custom: ClipboardList,
}

const PROPERTY_INFO_ICON_MAP: Record<PropertyInfoKey, LucideIcon> = {
  parking: ParkingCircle,
  waste: Recycle,
  supermarket: ShoppingBag,
}

const HIGHLIGHT_ICON_MAP: Record<HighlightSlot, LucideIcon> = {
  beach_now: Waves,
  morning_coffee: Coffee,
  lunch: UtensilsCrossed,
  dinner: Wine,
  activity_now: Compass,
  tomorrow_plan: CalendarDays,
}

export const NAV_ICON_MAP: Record<NavKey, LucideIcon> = {
  home: Home,
  explore: Compass,
  guide: BookOpen,
}

export function getPlaceIcon(type?: string | null): LucideIcon {
  const normalized = String(type || "").trim().toLowerCase()
  return PLACE_TYPE_ICON_MAP[normalized] || MapPin
}

export function getHouseRuleIcon(key: HouseRuleKey): LucideIcon {
  return HOUSE_RULE_ICON_MAP[key]
}

export function getPropertyInfoIcon(key: PropertyInfoKey): LucideIcon {
  return PROPERTY_INFO_ICON_MAP[key]
}

export function getHighlightIcon(slot: HighlightSlot): LucideIcon {
  return HIGHLIGHT_ICON_MAP[slot] || Compass
}
